export const environment = {
  production: true,
  baseUrl: 'https://api.courtagepatrimoine.net/'
};
